import { useTypedNode } from '@rehaje/react'

import { ValuableNode } from '../models/ValuableNode'

export const useValuableNode = <T extends ValuableNode>(): T | undefined => {
  const node = useTypedNode()
  return (node instanceof ValuableNode ? node : undefined) as T | undefined
}
